import {AccessJson} from "@amlCore/models";

export class Role {
  id: string;
  name: string;
  description: string;
  access: Array<AccessJson> = [];

  constructor() {
  }
}
